import { isArray } from 'util';
import { ManufacturingOrder } from './manufacturing-order';
import { Material } from './material';
import { Part } from './part';

export class CamData {
  public cam: string;
  public file: File;

  constructor(
    public manufacturingOrders: ManufacturingOrder[],
    public materials: Material[],
    public part: Part
  ) { }

  get isMultiple() {
    return (isArray(this.manufacturingOrders) && this.manufacturingOrders.length > 1);
  }

  get firstOrder() {
    return [ ...this.manufacturingOrders ].shift();
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/cam-data.ts